// ProviderDetailForm.js
import React, { useState, useEffect } from "react";
import { API_IP } from "../../env";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";

// Accept 'show' and 'onHide'
function ProviderDetailForm({
  show,
  onHide,
  providerID,
  providerName,
  setRefreshProvider,
  refreshProvider,
}) {
  const [providerData, setProviderData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  async function axiosReqConfig(url, method, data) {
    // ... (axiosReqConfig is the same)
    const bearerToken = localStorage.getItem("@uphealth_login_token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: data,
    };
    const returnData = await axios(reqConfig);
    return returnData;
  }

  async function getTheProviderData() {
    if (!providerID) return; // Don't fetch if no provider is selected
    setIsLoading(true);
    try {
      const { data } = await axiosReqConfig(
        `${API_IP}/api/admin/providers/${providerID}/detail`,
        "get",
        []
      ); //
      setProviderData(data);
    } catch (err) {
      console.error("Failed to fetch provider details", err);
      onHide(); // Close if data fails to load
    }
    setIsLoading(false);
  }

  async function UpdateVerification(verification) {
    setIsLoading(true);
    const options = verification ? "VERIFY" : "UNVERIFY";
    const answer = window.confirm(
      `Are you sure you want to ${options} this provider?`
    );
    if (answer) {
      await axiosReqConfig(`${API_IP}/api/admin/verification`, "patch", {
        provider_id: providerID,
        verification: verification,
      }); //
      setRefreshProvider((value) => !value);
      onHide(); // Close modal on success
    }
    setIsLoading(false);
  }

  useEffect(() => {
    // Fetch data only when the modal is opened
    if (show) {
      getTheProviderData();
    }
  }, [show, providerID]);

  // Handle loading state
  const renderLoading = () => (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "200px" }}
    >
      <Spinner animation="border" />
    </div>
  );

  // Handle data loaded state
  const renderDetails = () => (
    <Container fluid>
      <Row className="mb-3">
        <Col md={6}>
          <strong>Email</strong>
          <p>{providerData.email}</p>
        </Col>
        <Col md={6}>
          <strong>Phone Number</strong>
          <p>{providerData.phone_number}</p>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <strong>Address</strong>
          <p>
            {providerData.address}, {providerData.city}, {providerData.province}
            , {providerData.country}
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <strong>Open Hour</strong>
          <p>
            {providerData.opening_hour}
            {providerData.opening_hour < 12 ? "AM" : "PM"} -{" "}
            {providerData.closing_hour}
            {providerData.closing_hour >= 12 ? "PM" : "AM"}
          </p>
        </Col>
      </Row>
    </Container>
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header
        closeButton
        className={
          providerData?.verification
            ? "bg-success text-white"
            : "bg-warning text-dark"
        }
      >
        <Modal.Title>Details for: {providerName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading || !providerData ? renderLoading() : renderDetails()}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        {isLoading || !providerData ? null : providerData.verification ? (
          <Button
            variant="danger"
            onClick={() => {
              UpdateVerification(false);
            }}
          >
            Unverify this provider
          </Button>
        ) : (
          <Button
            variant="success"
            onClick={() => {
              UpdateVerification(true);
            }}
          >
            Verify this provider
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ProviderDetailForm;
